<template>
  <header class="n-header">
    <div class="container datos">
      <h3 class="name one">
        {{ name1 }}
      </h3>
      <span class="block"><i class="bx bx-git-compare"></i></span>
      <h3 class="name two">
        {{ name2 }}
      </h3>
    </div>
  </header>
</template>
<script>
export default {
  props: ["datosGrafica"],
  data() {
    return {
      name1: "",
      name2: "",
    };
  },
  mounted() {
    this.datosGrafica.forEach((i) => {
      if (i.titles.length > 1) {
        this.name1 = i.titles[0];
        this.name2 = i.titles[1];
      } else {
        this.name1 = i.titles[0];
        this.name2 = "Datos no Encontrados";
      }
    });
  },
};
</script>
<style scoped>
.n-header {
  height: 20vh;
  background: #e0e0e0;
  position: relative;
  display: flex;
  align-items: center;
}
.datos {
  display: flex;
  justify-content: center;
  align-items: center;
}
.name {
  font-size: 1.5rem;
  color: #052333;
  width: 33%;
  text-align: center;
  font-weight: bold;
}
.block {
  color: #052333;
  font-size: 3rem;
  text-align: center;
  width: 20%;
}
.one {
  border-bottom: 3px solid #770BAA;
}
.two {
  border-bottom: 3px solid #2ECC71;
}
</style>
